import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { L10N_LOCALE, L10nLocale } from 'angular-l10n';
import { AppConfig } from 'src/app/app.config';
import { ApiSelectorService } from './api-selector.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConfirmComponent } from '../modals/confirm/confirm.component';
import { UrlValidator } from '../validators/url-validator';

@Component({
  selector: 'app-api-selector',
  templateUrl: './api-selector.component.html',
  styleUrls: ['./api-selector.component.scss'],
  standalone: false
})
export class ApiSelectorComponent implements OnInit {
  
  embeddedHostControl = new UntypedFormControl();
  defaultEmbeddedHost: string = AppConfig.hosts.hickoryEmbed;
  hickoryHostControl = new UntypedFormControl();
  defaultHickoryHost: string = AppConfig.hosts.hickoryApi;

  constructor(
    @Inject(L10N_LOCALE) public locale: L10nLocale,
    private apiService: ApiSelectorService,
    private dialogRef: MatDialogRef<ApiSelectorComponent>,
    private dialog: MatDialog,
  ) { }

  ngOnInit() {
    this.configureControls();
  }

  updateEnvironments(): void {
    if (this.embeddedHostControl.valid) {
      this.apiService.addOverride(this.defaultEmbeddedHost, this.embeddedHostControl.value);
    }

    if (this.hickoryHostControl.valid) {
      this.apiService.addOverride(this.defaultHickoryHost, this.hickoryHostControl.value);
    }

    this.dialogRef.close();
  }

  resetEnvironments(): void {
    this.apiService.reset();
    this.updateControls();
  }

  disableChangeEnvironments() {
    this.dialog.open(ConfirmComponent, {
      width: '400px',
      data: { title: 'Disable Change Environment', message: 'You will need to login as a super admin in order to re-enable this option. This will also reset the environments to default values.<br><br>Do you want to disable changing environments (for testing against alternate hostnames)?' }
    }).afterClosed().subscribe( result => {
      if (result) {
        this.resetEnvironments();
        this.apiService.disableChangeEnvironments();
        this.dialogRef.close();
      }
    });
  }

  private configureControls() {
    this.updateControls();
    this.embeddedHostControl.addValidators(UrlValidator.validatorFn);
    this.embeddedHostControl.updateValueAndValidity();
    this.hickoryHostControl.addValidators(UrlValidator.validatorFn);
    this.hickoryHostControl.updateValueAndValidity();
  }

  private updateControls() {
    this.embeddedHostControl.setValue(this.apiService.getValue(this.defaultEmbeddedHost));
    this.hickoryHostControl.setValue(this.apiService.getValue(this.defaultHickoryHost));
  }
}
